const initialState = {};

function reducer(state = initialState, action) {
    switch (action.type) {
        case "benefit":
            return Object.assign({}, state, action.data);

        default:
            return state;
    }
}

const data = {
    name: "benefit",
    reducer: reducer,
};

export default data;